import script from "./goRinSyo0031.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0031.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0031.vue?vue&type=style&index=0&id=4980bb44&lang=scss"

const __exports__ = script;

export default __exports__